<div class="upsell-modal fixed w-full h-full flex items-center justify-center" *ngIf="show" (click)="onBackdropClick($event)">
  <div class="upsell-modal__container flex items-center justify-center w-full mx-auto">
    <div class="upsell-modal__content relative border w-full bg-cover border-gray-400" (click)="$event.stopPropagation()">
      
      <div class="upsell-modal__close-btn absolute text-xl flex items-center cursor-pointer right-5 top-5" (click)="onClose()">
        <span class="upsell-modal__close-cross font-normal cursor-pointer">&times;</span>
      </div>
      
      <div class="upsell-modal__main-content">
        
        <div class="upsell-modal__blue-section text-center p-6 pt-12 text-base text-white">
          <img class="upsell-modal__logo mb-3" [src]="LOGO" alt="Beverly Hills MD Logo">
          <div class="upsell-modal__green-header px-6 py-1 text-lg uppercase mb-6 font-semibold rounded-2xl">
            <h3 class="text-lg desktop:text-3xl m-0 font-bold" [innerHTML]="upsellModalInputs.title"></h3>
            <!-- HTML content from JSON -->
            <div [innerHTML]="upsellModalInputs.html"></div>
          </div> 
          <div class="upsell-modal__message flex flex-col justify-center" [innerHTML]="upsellModalInputs.message"></div>
        </div>
        
        <div class="upsell-modal__mobile-container desktop:hidden text-center">
          <img [src]="SCRUBS_IMAGE" class="upsell-modal__congrats-image w-1/2 m-auto z-40" alt="Beverly Hills MD Scrubs">
        </div>
        
        <img [src]="SCRUBS_IMAGE" class="upsell-modal__congrats-image-desktop right-0 bottom-0 absolute invisible desktop:visible" alt="Beverly Hills MD Scrubs">
        
        <div class="upsell-modal__cta-button text-center py-4 px-4 w-full text-white text-xl font-semibold rounded absolute cursor-pointer z-40" (click)="onCTA()" [innerHTML]="upsellModalInputs.buttonText"></div>
      </div>
      
    </div>
  </div>
</div> 